/* Aphrodisiac: Isolde buy box, format picker, swipeable photos and add to cart */
(function () {
  function money(cents, currency) {
    var whole = cents % 100 === 0;
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en', {
        style: 'currency', currency: currency || 'USD',
        minimumFractionDigits: whole ? 0 : 2, maximumFractionDigits: whole ? 0 : 2
      }).format(cents / 100);
    } catch (e) {
      return '$' + (cents / 100).toFixed(whole ? 0 : 2);
    }
  }

  function each(list, fn) { Array.prototype.forEach.call(list, fn); }

  function initBuy(el) {
    if (el.getAttribute('data-aph-ready')) return;
    el.setAttribute('data-aph-ready', '1');
    var currency = el.getAttribute('data-currency');
    var radios = Array.prototype.slice.call(el.querySelectorAll('[data-aph-format]'));
    var stage = el.querySelector('[data-aph-stage]');
    var slides = Array.prototype.slice.call(el.querySelectorAll('[data-aph-slide]'));
    var thumbs = el.querySelectorAll('[data-aph-thumb]');
    var rows = el.querySelectorAll('[data-aph-row]');
    var prevBtn = el.querySelector('[data-aph-prev]');
    var nextBtn = el.querySelector('[data-aph-next]');
    var gallery = el.querySelector('.aph-ib__gallery');
    var details = el.querySelector('[data-aph-details]');
    var idInput = el.querySelector('[data-aph-id]');
    var qtyInput = el.querySelector('[data-aph-qty]');
    var addBtn = el.querySelector('[data-aph-add]');
    var priceEl = el.querySelector('[data-aph-price]');
    var labelEl = el.querySelector('[data-aph-price-label]');
    var descEl = el.querySelector('[data-aph-desc]');
    var bar = el.querySelector('[data-aph-bar]');
    var barMeta = el.querySelector('[data-aph-bar-meta]');
    var barBtn = el.querySelector('[data-aph-bar-btn]');
    var addText = el.getAttribute('data-add-text') || 'Add to cart';
    var soonText = el.getAttribute('data-soon-text') || 'Coming soon';
    var soldText = el.getAttribute('data-sold-text') || 'Sold out';
    var shownFmt = null;
    var activeView = null;

    function current() {
      for (var i = 0; i < radios.length; i++) if (radios[i].checked) return radios[i];
      return radios[0];
    }

    /* ---------- photos: one swipeable strip per format ---------- */
    function visible() {
      return slides.filter(function (s) { return !s.classList.contains('is-off'); });
    }
    function width() { return stage ? Math.max(1, stage.clientWidth) : 1; }
    function index() { return stage ? Math.round(stage.scrollLeft / width()) : 0; }

    function showFormat(fmt) {
      if (fmt === shownFmt) return;
      shownFmt = fmt;
      slides.forEach(function (s) { s.classList.toggle('is-off', s.getAttribute('data-aph-fmt') !== fmt); });
    }

    function mark(view) {
      activeView = view;
      slides.forEach(function (s) { s.classList.toggle('is-active', s.getAttribute('data-aph-slide') === view); });
      each(thumbs, function (t) {
        var on = t.getAttribute('data-aph-thumb') === view;
        t.classList.toggle('is-active', on);
        t.setAttribute('aria-pressed', on ? 'true' : 'false');
        if (on) keepInStrip(t);
      });
      arrows();
    }

    function keepInStrip(t) {
      var strip = t.parentElement;
      if (!strip || strip.scrollWidth <= strip.clientWidth) return;
      var left = t.offsetLeft - strip.offsetLeft;
      if (left < strip.scrollLeft) strip.scrollLeft = left;
      else if (left + t.offsetWidth > strip.scrollLeft + strip.clientWidth) strip.scrollLeft = left + t.offsetWidth - strip.clientWidth;
    }

    function arrows() {
      var n = visible().length;
      var i = index();
      if (prevBtn) { prevBtn.hidden = n < 2; prevBtn.disabled = i <= 0; }
      if (nextBtn) { nextBtn.hidden = n < 2; nextBtn.disabled = i >= n - 1; }
    }

    function show(view, smooth) {
      var slide = null;
      for (var i = 0; i < slides.length; i++) if (slides[i].getAttribute('data-aph-slide') === view) { slide = slides[i]; break; }
      if (!slide) return;
      showFormat(slide.getAttribute('data-aph-fmt'));
      var pos = visible().indexOf(slide);
      if (stage) {
        var left = pos * width();
        if (smooth && 'scrollBehavior' in document.documentElement.style) stage.scrollTo({ left: left, behavior: 'smooth' });
        else stage.scrollLeft = left;
      }
      mark(view);
    }

    function go(step) {
      var vis = visible();
      var i = Math.max(0, Math.min(vis.length - 1, index() + step));
      if (vis[i]) show(vis[i].getAttribute('data-aph-slide'), true);
    }

    if (stage) {
      var settle = null;
      stage.addEventListener('scroll', function () {
        clearTimeout(settle);
        settle = setTimeout(function () {
          var vis = visible();
          var s = vis[Math.max(0, Math.min(vis.length - 1, index()))];
          if (s && s.getAttribute('data-aph-slide') !== activeView) mark(s.getAttribute('data-aph-slide'));
          else arrows();
        }, 90);
      }, { passive: true });
      stage.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { e.preventDefault(); go(1); }
        if (e.key === 'ArrowLeft') { e.preventDefault(); go(-1); }
      });
    }
    if (prevBtn) prevBtn.addEventListener('click', function () { go(-1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { go(1); });

    /* ---------- format, price and buttons ---------- */
    function update(changeView) {
      var r = current();
      if (!r) return;
      radios.forEach(function (x) {
        var opt = x.closest('.aph-ib__opt');
        if (opt) opt.classList.toggle('is-checked', x.checked);
      });
      each(rows, function (row) { row.classList.toggle('is-current', row.getAttribute('data-aph-row') === r.value); });
      var variant = r.getAttribute('data-variant');
      var cents = parseInt(r.getAttribute('data-cents') || '0', 10);
      var available = r.getAttribute('data-available') === 'true';
      var qty = Math.max(1, parseInt((qtyInput && qtyInput.value) || '1', 10) || 1);
      if (priceEl) priceEl.textContent = r.getAttribute('data-price');
      if (labelEl) labelEl.textContent = r.getAttribute('data-label');
      if (descEl) descEl.textContent = r.getAttribute('data-desc');
      if (idInput) idInput.value = variant || '';
      if (details) {
        var url = r.getAttribute('data-url');
        if (url) { details.href = url; details.hidden = false; } else { details.hidden = true; }
      }
      var text = addText;
      var disabled = false;
      if (!variant) { text = soonText; disabled = true; }
      else if (!available) { text = soldText; disabled = true; }
      else { text = addText + ', ' + money(cents * qty, currency); }
      if (addBtn) { addBtn.textContent = text; addBtn.disabled = disabled; }
      if (barBtn) { barBtn.textContent = disabled ? text : addText; barBtn.disabled = disabled; }
      if (barMeta) barMeta.textContent = r.getAttribute('data-short') + ', ' + r.getAttribute('data-price');
      if (changeView) show(r.getAttribute('data-view'), false);
    }

    radios.forEach(function (r) { r.addEventListener('change', function () { update(true); }); });

    each(thumbs, function (t) {
      t.addEventListener('click', function () {
        var key = t.getAttribute('data-for');
        var view = t.getAttribute('data-aph-thumb');
        var changed = false;
        for (var i = 0; i < radios.length; i++) {
          if (radios[i].value === key && !radios[i].checked) { radios[i].checked = true; changed = true; }
        }
        if (changed) update(false);
        show(view, !changed);
      });
    });

    each(el.querySelectorAll('[data-aph-step]'), function (b) {
      b.addEventListener('click', function () {
        if (!qtyInput) return;
        var v = parseInt(qtyInput.value || '1', 10) || 1;
        v = Math.min(99, Math.max(1, v + parseInt(b.getAttribute('data-aph-step'), 10)));
        qtyInput.value = v;
        update(false);
      });
    });
    if (qtyInput) qtyInput.addEventListener('input', function () { update(false); });

    el.aphPick = function (key) {
      for (var i = 0; i < radios.length; i++) {
        if (radios[i].value === key) { radios[i].checked = true; update(true); return; }
      }
    };
    el.aphRefresh = function () { update(false); };

    /* On large screens the photo column follows you down the page. With three rows of
       thumbnails it can be taller than the screen, so let it scroll until its bottom shows. */
    function fitGallery() {
      if (!gallery) return;
      gallery.style.top = '';
      if (window.getComputedStyle(gallery).position !== 'sticky') return;
      var header = parseFloat(window.getComputedStyle(document.body).getPropertyValue('--header-height')) || 0;
      var room = window.innerHeight - gallery.offsetHeight - 24;
      gallery.style.top = Math.min(header + 24, room) + 'px';
    }
    var resizeTimer = null;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        fitGallery();
        if (activeView) show(activeView, false);
      }, 120);
    });
    window.addEventListener('load', fitGallery);

    if (bar && addBtn && 'IntersectionObserver' in window) {
      document.body.classList.add('aph-has-bar');
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          bar.classList.toggle('is-visible', !e.isIntersecting && e.boundingClientRect.top < 0);
        });
      });
      io.observe(addBtn);
    }

    update(true);
    fitGallery();
  }

  /* ---------- add to cart without leaving the page ---------- */
  function cartAddUrl() {
    try {
      if (typeof Theme !== 'undefined' && Theme.routes && Theme.routes.cart_add_url) return Theme.routes.cart_add_url;
    } catch (e) {}
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return root + 'cart/add.js';
  }

  function cartSectionIds() {
    var ids = [];
    each(document.querySelectorAll('cart-items-component'), function (c) {
      if (c.dataset && c.dataset.sectionId) ids.push(c.dataset.sectionId);
    });
    return ids;
  }

  /* Tell the theme (and any cart app listening to it) that the cart changed, so the cart opens and the count updates */
  function announceCartAdd(target, variantId, quantity, sections) {
    var data = { source: 'product-form-component', itemCount: quantity, sections: sections };
    function plain() {
      target.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { resource: {}, sourceId: String(variantId || ''), data: data } }));
    }
    try {
      import('@theme/events')
        .then(function (m) { target.dispatchEvent(new m.CartAddEvent({}, String(variantId || ''), data)); })
        .catch(plain);
    } catch (e) {
      plain();
    }
  }

  function busy(buttons, text) {
    var labels = buttons.map(function (b) { return b.textContent; });
    buttons.forEach(function (b) { b.disabled = true; b.textContent = text; });
    return function restore() { buttons.forEach(function (b, i) { b.disabled = false; b.textContent = labels[i]; }); };
  }

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.closest || !form.closest('.aph-ib, .aph-iset')) return;
    if (!/\/cart\/add/.test(form.getAttribute('action') || '')) return;
    if (!window.fetch || !window.FormData) return;
    e.preventDefault();

    var buttons = Array.prototype.filter.call(document.querySelectorAll('button[type="submit"]'), function (b) { return b.form === form; });
    var restore = busy(buttons, 'Adding');
    function done() {
      restore();
      var buy = form.closest('[data-aph-buy]');
      if (buy && buy.aphRefresh) buy.aphRefresh();
    }

    var body = new FormData(form);
    var sectionIds = cartSectionIds();
    if (sectionIds.length) body.append('sections', sectionIds.join(','));

    fetch(cartAddUrl(), {
      method: 'POST',
      body: body,
      headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' }
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res && res.status) {
          var msg = res.description || res.message || 'Could not add to cart';
          buttons.forEach(function (b) { b.textContent = msg; });
          setTimeout(done, 3000);
          return;
        }
        done();
        announceCartAdd(form, body.get('id'), Number(body.get('quantity')) || 1, res && res.sections);
      })
      .catch(function () {
        done();
        form.submit();
      });
  }, true);

  /* The set: one of each format in a single tap */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-aph-add-set]');
    if (!btn) return;
    e.preventDefault();
    var ids = (btn.getAttribute('data-aph-add-set') || '').split(',').filter(Boolean);
    if (!ids.length || !window.fetch) return;
    var restore = busy([btn], 'Adding');
    var payload = { items: ids.map(function (id) { return { id: Number(id), quantity: 1 }; }) };
    var sectionIds = cartSectionIds();
    if (sectionIds.length) payload.sections = sectionIds.join(',');
    fetch(cartAddUrl(), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(payload)
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res && res.status) {
          btn.textContent = res.description || res.message || 'Could not add to cart';
          setTimeout(restore, 3000);
          return;
        }
        restore();
        announceCartAdd(btn, ids[0], ids.length, res && res.sections);
      })
      .catch(function () {
        restore();
        window.location.href = ((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/') + 'cart';
      });
  });

  /* Buttons elsewhere on the page that pick a format in the buy box */
  document.addEventListener('click', function (e) {
    var link = e.target.closest && e.target.closest('[data-aph-format-pick]');
    if (!link) return;
    var buy = document.querySelector('[data-aph-buy]');
    if (buy && buy.aphPick) buy.aphPick(link.getAttribute('data-aph-format-pick'));
  });

  function initAll(scope) {
    each((scope || document).querySelectorAll('[data-aph-buy]'), initBuy);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  document.addEventListener('shopify:block:select', function (e) {
    var buy = e.target.closest && e.target.closest('[data-aph-buy]');
    var input = e.target.querySelector && e.target.querySelector('[data-aph-format]');
    if (buy && buy.aphPick && input) buy.aphPick(input.value);
  });
})();
